import { Button as AntdButton, ButtonProps } from 'antd'

export const Button = (props: ButtonProps) => <AntdButton {...props} />
